import { defineStore } from 'pinia'
// import { getMenusByInst } from '@/service/menu.service

export const useMenuStore = defineStore('menu', {
    state: () => ({
        currentMenuId: null,
        previousMenuId: null
    }),
    actions: {
        // async reloadMenus({ instCd }) {
        //     const res = await getMenusByInst({ instCd })
        //     this.menus = Array.isArray(res?.data) ? res.data : []
        // },
        setCurrentMenu(menuId) {
            if (this.currentMenuId !== menuId) {
                this.previousMenuId = this.currentMenuId
            }
            this.currentMenuId = menuId
        },
        resetCurrentMenu() {
            this.previousMenuId = this.currentMenuId
            this.currentMenuId = null
        },
        // 이전 메뉴로 돌아가기
        restorePreviousMenu() {
            this.currentMenuId = this.previousMenuId
        }
    }
})